import {Observable} from 'rxjs/index';
import {EventEmitter, Injectable} from '@angular/core';
import {ApprovalPending} from '../shared/dto/approval-pending';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApprovalModel} from '../shared/dto/approval.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DispatchPendingModel} from '../shared/dto/dispatch-pending.model';
import { saveAs } from 'file-saver';
import {Router} from '@angular/router';
import {DispatchSidModel} from '../shared/dto/dispatch-sid.model';
import {AppConfig} from '../shared/common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ApprovalService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig,
              private router: Router) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/approve/';
  baseUrl1: string = this.appConfig.getConfig('BASE_URL_TWO') + 'api/applicantRequest';
  private headers;
  public model = new EventEmitter<NgbModal>();
  public closeModel: NgbModal;
  public reqCount: number = 0;
  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  searchApprovalPendingData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'getApprovalPendingRequest', data);
  }

  searchApplicantData(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'getApplicantData/'+ applicationId);
  }

  proceedPersonalData(personalDto: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'saveApplicantData', personalDto,{headers: this.headers});
  }

  proceedContactData(contactDto: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'saveContactData', contactDto,{headers: this.headers});
  }

  rejectRequest(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'rejectRequest', approvalModel, {headers: this.headers});
  }

  setModel(mod: NgbModal) {
    this.closeModel = mod;
    this.model.emit(this.closeModel);
  }

  close() {
    this.closeModel.dismissAll();
  }

  forwardtoDg(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'forwardToDg', approvalModel, {headers: this.headers});
  }

  returnRequest(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'returnRequest', approvalModel, {headers: this.headers});
  }

  approveRequeat(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'approveRequest', approvalModel, {headers: this.headers});
  }

  searchDuplicateApplicantData(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'getDuplicateApplicantData/' + applicationId);
  }

  lockRequest(applicationId: number):Observable<object>{
    return this.httpClient.get(this.baseUrl + 'lockRequest/' + applicationId);
  }

  unlockRequest(applicationId: number):Observable<object>{
    return this.httpClient.get(this.baseUrl + 'unlockRequest/' + applicationId);
  }

  getApplicantDetails(refferenceNo: number):any{
    return this.httpClient.get(this.baseUrl1 + '/'+ refferenceNo,{headers: this.headersJson});
  }

  searchScanPendingData(scanPending: DispatchPendingModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'getScanPendingRequest', scanPending);
  }

  sendToDispatch(sid: DispatchPendingModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'sendToDispatch', sid);
  }

  searchDispatchPendingData(scanPending: DispatchPendingModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'getDispatchPendingRequest', scanPending);
  }

  dispatchSidGenerateList(arr: string[]): any{
    return this.httpClient.get(this.baseUrl + 'dispatchExcelGenerate/'+arr, {headers: this.headersJson, responseType: 'blob'})
      .subscribe(res => {
        const blobb = new Blob([res], {type: res.type});
        saveAs(blobb, 'sid.xls');
        this.router.navigate(['/dashboard/dashHome'] );
      }, error1 => {
        alert('Sorry file not available!');
      });
  }

  searchSidApplicantData(dispatchDto: DispatchSidModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'getSidApplicantData' ,dispatchDto);
  }

  dispatch(dispatchDto: DispatchSidModel): Observable<Object>  {
    return this.httpClient.post(this.baseUrl + 'dispatchCard', dispatchDto);
  }

}
